import { useState, useRef, useEffect } from 'react'
import { FaBullhorn, FaTimes } from 'react-icons/fa'
import { NotificationBannerProps } from './NotificationBanner.types'
import styles from './NotificationBanner.module.css'

const NotificationBanner = ({ messages }: NotificationBannerProps) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0)
  const [visible, setVisible] = useState(true)
  const messageRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % messages.length)
    }, 10000)

    return () => clearInterval(interval)
  }, [messages.length])

  if (!visible || !messages.length) return null

  const currentMessage = messages[currentMessageIndex]

  return (
    <div
      className={`${styles.banner} w-full bg-[var(--notification-bg)] text-[var(--notification-text)] flex items-center px-4 py-3 overflow-hidden`}
    >
      {/* Icon */}
      <FaBullhorn className="text-[var(--notification-icon)] text-4xl mr-4 flex-shrink-0" />

      {/* Message */}
      <div className="relative overflow-hidden w-full">
        <div
          ref={messageRef}
          className="whitespace-nowrap text-lg font-semibold w-max animate-marquee"
          key={currentMessageIndex}
        >
          {currentMessage.text}
        </div>
      </div>

      {/* Close Button */}
      <button
        type="button"
        onClick={() => setVisible(false)}
        title="Close notification"
        aria-label="Close notification"
        className="cursor-pointer"
      >
        <FaTimes className="text-[var(--notification-icon)] ml-4" />
      </button>
    </div>
  )
}

export default NotificationBanner
